import { render } from "./EditPostModal.vue?vue&type=template&id=1bc0be4f&scoped=true"
import script from "./EditPostModal.vue?vue&type=script&lang=js"
export * from "./EditPostModal.vue?vue&type=script&lang=js"

import "./EditPostModal.vue?vue&type=style&index=0&id=1bc0be4f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc0be4f"]])

export default __exports__